import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useInstallations } from '@/features/installations/hooks/useInstallations'

export function useInstallationFromParams() {
  const { installationId } = useParams<{ installationId: string }>()
  const { data: installations } = useInstallations()

  return useMemo(() => {
    if (!installationId || !installations) {
      return undefined
    }
    return installations.find((item) => item.id === installationId)
  }, [installationId, installations])
}
